import React from 'react';
import { NavLink } from 'react-router-dom';
import LineIcon from 'react-lineicons';
import { blackOrWhite, menuHover } from '../../../../Infrastructure/ManipulateColors';

const SettingsNav = props => {
    return (
        <>
            <li data-toggle="collapse" href="#settingsDropdown" role="button" style={{ "--hover-color": menuHover(props.context.primaryNavColour) }}>
                <div className="chev">
                    <LineIcon name="chevron-right" style={{ color: props.context.sidebarIconColour }} />
                </div>
                <NavLink to="#" activeClassName='sidebar-active'>
                    <LineIcon name="cogs" style={{ color: props.context.sidebarIconColour }} />
                    <span className="item" style={{ color: props.context.primaryNavColour ? blackOrWhite(props.context.primaryNavColour) : "black" }}>Settings</span>
                </NavLink>
            </li>

            <div className="collapse" id="settingsDropdown">
                <div className="sidebar-submenu">
                    <ol style={{ "backgroundColor": props.manipulateColours(props.context.primaryNavColour) }}>
                        <li style={{ "--sub-menu-hover-color": menuHover(props.manipulateColours(props.context.primaryNavColour)), "--ol-color": blackOrWhite(props.context.primaryNavColour) }}><NavLink activeClassName='sidebar-active' to="/settings/theme"><span>Theme</span></NavLink></li>
                    </ol>
                </div>
            </div>
        </>
    );
};

export default SettingsNav;